import { t } from "../../../../i18n";
import { useState } from 'react';
import { portalConfig } from '../../../../configs/portal';
import { useTheme } from '@mui/material/styles';
import { Grid2 as Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import AuthLogin from '../auth-forms/AuthLogin';
import AuthEmailOtp from '../auth-forms/AuthEmailOtp';

// ================================|| AUTH3 - LOGIN ||================================ //

function Login() {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
  const [loginMethod, setLoginMethod] = useState('password');
  const isEmailOtp = loginMethod === 'emailOtp';
  return <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid size={12}>
                <Grid container direction={matchDownSM ? 'column-reverse' : 'row'} alignItems="center" justifyContent="center">
                    <Grid size={12}>
                        <Stack alignItems="center" justifyContent="center" spacing={1}>
                            <Typography color="accent.main" component="h1" sx={{
              textAlign: 'center',
              textWrap: 'balance',
              width: '100%',
              lineHeight: 1.3
            }} variant={matchDownSM ? 'h3' : 'h2'}>
                                {t(portalConfig.title)}
                            </Typography>
                            <Typography variant="caption" fontSize="16px" textAlign="center">
                                {isEmailOtp ? t('Aceda com um código enviado por email') : t('Introduza as suas credenciais')}
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={12}>
                {isEmailOtp ? <AuthEmailOtp onUsePassword={() => setLoginMethod('password')} /> : <AuthLogin onUseEmailOtp={() => setLoginMethod('emailOtp')} />}
            </Grid>
        </Grid>;
}
export default Login;
